import { render, staticRenderFns } from "./Extras.vue?vue&type=template&id=570f5a24&scoped=true"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f5a24",
  null
  
)

export default component.exports